module.exports = __webpack_public_path__ + "a816f3a2978c63034949667c78ebf5fd.svg";